//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {emitLanguageChange} from "../js/components/htmlTranslation";
import YandexShare from '@cookieseater/vue-yandex-share';

export default {
  components: {
    YandexShare
  },
  data() {
    return {
      locales: {
        ru: 'rus',
        en: 'eng',
      },
      localeLink: '#'
    }
  },
  created() {
    const newLocale = Object.keys(this.locales).find((obj)=>{return obj !== this.$i18n.locale});
    this.localeLink = document.getElementById('page-link-' + newLocale).getAttribute('href');
  },
  computed: {
    isMenuOpened() {
      return this.$store.state.isMenuOpened;
    }
  },
  methods: {
    changeLocale(event) {
      // event.preventDefault();
      this.$i18n.locale = Object.keys(this.locales).find((obj)=>{return obj !== this.$i18n.locale});
      const newUrl = document.getElementById('page-link-' + this.$i18n.locale).getAttribute('href');
      // window.location.href = newUrl;
      // window.history.pushState({lang: this.$i18n.locale}, "", newUrl);
      emitLanguageChange();
    },
    copyUrl() {
      let dummy = document.createElement('input'),
          text = window.location.href;

      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },
    toggleMenu() {
      this.$store.dispatch('menuOpen', !this.isMenuOpened );
    }
  }
};
